// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    useLocation,
} from 'react-router-dom'

// data
import {
    defaultReduxState,
    reduxFormSetRefreshSite,
    reduxModalErrorEventHandlerSite,
} from 'data'

import {
    DetailAction825,
    DetailContentBlock825,
    DetailContentTabButton825,
    MainFormModalWrapper825,
} from 'pages'

// serializers
import {
    ContentTypeDetailTypes,
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template825SiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
    parseQuerySite,
} from 'services'

type Item = {
    id: number;
    title?: string;
    blockList?: any[];
    blockFieldSet?: object;
    blockInLine?: object;
    panelOptions?: object;
};

// props
type TemplateBlock825SiteProps = {
    blockId: string
    content: Template825SiteSerializer | undefined
    contentArray?: any[]
    detailId: string | undefined
    devId: string | undefined
    isEditHovered: boolean
    isInDetailPage?: boolean
    object: PortfolioPageContentListSiteSerializer
    pageSlug: string | undefined
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock825Site: React.FC<TemplateBlock825SiteProps> = React.memo(({
    blockId,
    content,
    contentArray,
    detailId,
    devId,
    isEditHovered,
    isInDetailPage,
    object,
    pageSlug,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const location = useLocation()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [stylesNew, setStylesNew] = useState<CustomCSSProperties | undefined>(applyStyles())

    const contentType = content?.content?.content_type_string || 'dataset_entity' // TODO

    const app = contentType?.split('_')[0]
    // const model = contentType?.split('_')[1]
    const panelsSubContentType: ContentTypeDetailTypes['panels'] = content?.content_type_settings_custom?.detail?.panelsSubContentType?.[content?.sub_content_type.id]?.panels
    const firstTab = panelsSubContentType?.[0]?.id

    const [tab, setTab] = useState<(number)>(Number(parseQuerySite(location.search)?.tab) || firstTab)

    const tabData = panelsSubContentType?.find(obj => obj.id === tab)

    useEffect(() => {
        const parsed = parseQuerySite(location.search)
        if (parsed.tab) {
            setTab(Number(parsed.tab))
        } else {
            setTab(firstTab)
        }
    }, [
        contentType,
        object.id,
        location.search,
    ])

    useEffect(() => {
        setStylesNew(applyStyles())
    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])

    function applyStyles() {
        try {
            return getStylesNew(reduxModalSite, styles, stylesEdit) || {}
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock825Site',
                'applyStyles',
            ))
        }
    }

    if (!tabData) return null

    return (
        <div className={`template-block-825-detail-component`}>
            <div className='dc-tabs'>
                <DetailAction825
                    contentType={contentType}
                    contentTypeSettings={content?.content_type_settings_json}
                    contentTypeSettingsCustom={content?.content_type_settings_custom?.[contentType]}
                    object={content?.content}
                    refreshData={() => dispatch(reduxFormSetRefreshSite('refreshDetailSite'))}
                />
                <div className='dc-buttons'>
                    {panelsSubContentType.map(val => (
                        <DetailContentTabButton825
                            key={val.id}
                            panel={val}
                            setTab={setTab}
                            tab={tab}
                        />
                    ))}
                </div>
            </div>
            <DetailContentBlock825
                contentType={contentType}
                contentTypeSettings={content?.content_type_settings_json}
                contentTypeSettingsCustom={content?.content_type_settings_custom}
                object={content?.content}
                subContentTypeForced={content?.sub_content_type}
                tab={tab}
                tabData={tabData}
            />
            <MainFormModalWrapper825 />
        </div>
    )
})
